import { CheckIcon, CopyIcon } from '@radix-ui/react-icons'
import { DataTestIDs } from 'shared/constants'
import { NeonButton } from 'shared/ui/neon'
import { useCopyAddress } from '../hooks/use-copy-address'
import styles from '../neon-wallets.module.scss'

interface Props {
  address: string
  /** A small icon next to an address, or the dialog's main button. */
  variant?: 'icon' | 'button'
  testId: DataTestIDs
}

export const CopyAddressButton: React.FC<Props> = ({
  address,
  variant = 'icon',
  testId
}) => {
  const { isCopied, copy } = useCopyAddress(address)
  const icon = isCopied ? <CheckIcon /> : <CopyIcon />

  if (variant === 'button') {
    return (
      <NeonButton
        type='button'
        iconLeft={icon}
        onClick={() => void copy()}
        data-testid={testId}
      >
        {isCopied ? 'Copied!' : 'Copy address'}
      </NeonButton>
    )
  }

  return (
    <button
      type='button'
      className={styles.iconButton}
      data-copied={isCopied}
      aria-label={isCopied ? 'Address copied' : 'Copy address'}
      onClick={() => void copy()}
      data-testid={testId}
    >
      {icon}
    </button>
  )
}
